export type InputType =
    | 'text'
    | 'password'
    | 'tel'
    | 'number'
    | 'money'
    | 'card'
    | 'search';

export const defaultInputType: InputType = 'text';

export enum TextAlign {
    left = 'left',
    right = 'right',
    center = 'center',
}

export type TextAlignType = 'left' | 'right' | 'center';

export enum InputSize {
    dense = 'dense',
    free = 'free',
}
export const defaultInputSize: InputSize = InputSize.dense;

export type InputSizeType = 'dense' | 'free';
